export class RingBuffer<T> {
  private buffer: T[] = [];
  private head = 0;
  private full = false;

  constructor(private maxSize: number) {}

  push(item: T): void {
    if (this.full) {
      this.buffer[this.head] = item;
    } else if (this.buffer.length < this.maxSize) {
      this.buffer.push(item);
      if (this.buffer.length === this.maxSize) {
        this.full = true;
      }
      this.head = this.buffer.length % this.maxSize;
      return;
    }
    this.head = (this.head + 1) % this.maxSize;
  }

  getAll(): T[] {
    if (!this.full) {
      return this.buffer.slice();
    }
    return [...this.buffer.slice(this.head), ...this.buffer.slice(0, this.head)];
  }

  clear(): void {
    this.buffer = [];
    this.head = 0;
    this.full = false;
  }

  get size(): number {
    return this.full ? this.maxSize : this.buffer.length;
  }
}
